/** 
 *  ==========================
 *  BLOCK: Shortcode
 *  ==========================
 */

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'

/**
 * External dependencies
 */
import { disabledBlocks, i18n } from 'cartzillagb'

/**
 * Internal dependencies
 */
import edit from './edit'
import save from './save'

const schema = {
	label: {
		type: 'string',
	},
	placeholder: {
		type: 'string',
	},
	text: {
		type: 'string',
	},
	className: {
		type: 'string',
	},
	'uniqueClass' : {
		type: 'string',
	}
}

export const name = 'czgb/shortcode'

export const settings = {
	title: __( 'Advanced Shortcode', i18n ),
	description: __( 'Add a shortcode to your page.', i18n ),
	example: {},
	category: 'cartzillagb',
	keywords: [
		__( 'Advanced Shortcode', i18n ),
		__( 'CartzillaGB', i18n ),
	],
	attributes: schema,

	edit,
	save,

	supports: {
		inserter: ! disabledBlocks.includes( name ), // Hide if disabled.
	}
}